module.exports = __webpack_public_path__ + "img/_88A4264.6ffbbc2a.jpg";